import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { get } from 'lodash';
import { Subscription } from 'rxjs';

import { AvailableLang } from 'ideta-library/lib/utils/utils';

import { environment } from '../../environments/environment';

import { AuthService } from '../shared/services/auth/auth.service';
import { FeedbackService } from '../shared/services/feedback/feedback.service';
import { ProtocolDroidService } from '../shared/services/protocol-droid/services/protocol-droid.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  credentials: any;
  customMessage: string;
  emailInput: string;
  signInError: string;
  isWebMode: boolean;
  signupUrl: string;
  forgotPasswordUrl: string;
  private subscriptions: Subscription[];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private protocolDroidService: ProtocolDroidService,
    private feedbackService: FeedbackService,
    private platform: Platform
  ) {
    this.subscriptions = [];
  }

  ngOnInit() {
    this.isWebMode = this.platform.is('desktop');
    this.signupUrl = `${environment.products.connect}/signup${this.isWebMode ? '' : '?origin=mobile'}`;
    this.forgotPasswordUrl = `${environment.products.connect}/forgot-password${this.isWebMode ? '' : '?origin=mobile'}`;

    this.protocolDroidService.setLang((get(navigator, 'language') || get(navigator, 'userLanguage')) as AvailableLang);
    setTimeout(() => {
      this.feedbackService.hideSpinner();
      this.authService.closeUnexpectedPopups();
    }, 1000);
    this.subscriptions.push(
      this.authService.getAuth().subscribe(() => {
        this.router.navigate(['/projects']);
      }),
      this.route.queryParamMap.subscribe((params: ParamMap) => {
        this.customMessage = params.get('message');
        this.emailInput = params.get('email');
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  loginWithCredentials(event: any, email: string, password: string): void {
    // Necessary to stop events from ENTER key
    event.stopPropagation();
    event.preventDefault();
    this.signInError = null;
    this.authService.loginWithCredentials({ email, password }).catch(() => {
      this.signInError = this.protocolDroidService.translate('login.invalid-credentials');
    });
  }

  googleAuth(): void {
    this.authService.signinWithGoogle();
  }

  microsoftAuth(): void {
    this.authService.signinWithMicrosoft();
  }
}
